export default {"src":"/_next/static/media/laravel_logo_3564e2fbbc.9b7a09de.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};